import {
  SET_SELECTED_FACILITY,
  SelectedFacilityType
} from "store/actions/trainerDashboardPageForecast";
import { ITrainerDashboardPageForecastState } from "interfaces/ITrainerDashboardPageForecastState";

const initialState: ITrainerDashboardPageForecastState = {
  selectedFacility: null
};

export default (
  state = initialState,
  action: SelectedFacilityType
): ITrainerDashboardPageForecastState => {
  switch (action.type) {
    case SET_SELECTED_FACILITY:
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    default:
      return state;
  }
};
